import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from 'react';
export var useDynamicIntersection = function useDynamicIntersection(callback) {
  var _useState = useState(function () {
      return typeof window !== 'undefined' ? new IntersectionObserver(callback, {
        threshold: 0.65
      }) : undefined;
    }),
    _useState2 = _slicedToArray(_useState, 1),
    observer = _useState2[0];
  return function (elements) {
    elements.forEach(function (el) {
      return observer === null || observer === void 0 ? void 0 : observer.observe(el);
    });
  };
};